import { takeLatest, call, put } from "redux-saga/effects";
import {
  SETTINGS_EMAIL_ADD_REQUEST,
  settingsEmailAdded,
  settingsEmailAddError,
} from "../../actions/global-settings";
import addEmail from "../../../../../backend/oncall/partners/contact-details/emails/add";

const requestAddEmail = function*(action) {
  try {
    yield call(addEmail, action.payload.email);
    yield put(settingsEmailAdded(action.payload.email));
  } catch (error) {
    yield put(settingsEmailAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(SETTINGS_EMAIL_ADD_REQUEST, requestAddEmail);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/global-settings/request-add-email.js